import React, { useState } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Avatar, Box, Button, Chip, Grid, Typography } from "@mui/material";
import TableComponent from "components/grid";
import TitleBar from "components/TitleBar";
import { exportToExcel } from "utils/ExportToExcel";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "config";

// const rfqData = [
//   {
//     id: 1,
//     title: "Electrical",
//     description: "Power Supply on - 33KV/11KV Feeder Line and Main Substation.Power Distribution to Infra Facilities including Street Lights, High Mast, Utility Buildings, Admin Building, Truck Parking, ICD, DCT, BWH, Rail Yard & PF.",
//     plannedDate: "7 JAN, 2026",
//     actualDate: "NA",
//     avatar: "EL",
//     bgcolor: "#F7C7C3",
//     color: "#F15744",
//   },
//   {
//     id: 2,
//     title: "STP-ITC",
//     description: "",
//     plannedDate: "08 JAN, 2026",
//     actualDate: "NA",
//     avatar: "ST",
//     bgcolor: "#F7C7C3",
//     color: "#F15744",
//   },
//   {
//     id: 3,
//     title: "OWC - organic waste collector (near STP)",
//     description: "",
//     plannedDate: "13 JAN, 2026",
//     actualDate: "NA",
//     avatar: "ST",
//     bgcolor: "#F7C7C3",
//     color: "#F15744",
//   },
//   {
//     id: 4,
//     title: "Fire Fighting",
//     description: "Internal fire system",
//     plannedDate: "17 JAN, 2026",
//     actualDate: "NA",
//     avatar: "FF",
//     bgcolor: "#DCFCE7",
//     color: "#3CD856",
//   },
//   {
//     id: 5,
//     title: "Electrical",
//     description: "Internal electrical system;Building earthing system;Toilets Internal electrical including exhaust system;Street Lights",
//     plannedDate: "27 JAN, 2026",
//     actualDate: "NA",
//     avatar: "EL",
//     bgcolor: "#DCFCE7",
//     color: "#3CD856",
//   },
//   {
//     id: 6,
//     title: "Electrical",
//     description: "CCTV; RF Tower; Access control; Local exchange telephones; ",
//     plannedDate: "27 JAN, 2026",
//     actualDate: "NA",
//     avatar: "EL",
//     bgcolor: "#DCFCE7",
//     color: "#3CD856",
//   },
//   {
//     id: 7,
//     title: "Electrical",
//     description: "CCTV;Local exchange telephones; Access control; FAPA & Detection system with equipment (only for admin bldg, DCT & BWH) ",
//     plannedDate: "27 JAN, 2026",
//     actualDate: "NA",
//     avatar: "EL",
//     bgcolor: "#DCFCE7",
//     color: "#3CD856",
//   },
//   // {
//   //   id: 3,
//   //   title:
//   //     "Internal electrical system;Building earthing system;Toilets Internal electrical including exhaust system;FA & Detection system.",
//   //   //poDate: "N.A",
//   //   plannedDate: "30 DEC, 2025",
//   //   actualDate: "N.A",
//   //   avatar: "MD",
//   // },
// ];

const rfqData = [
    {
    id: 1,
    title: "Elevator",
    description: "",
    plannedDate: "28 FEB, 2026",
    actualDate: "NA",
    avatar: "PE",
    bgcolor: "#F7C7C3",
    color: "#F15744",
  },
  // {
  //   id: 1,
  //   title: "Electrical Works",
  //   description: "",
  //   plannedDate: "10 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "EW",
  //   bgcolor: "#F7C7C3",
  //   color: "#F15744",
  // },
  // {
  //   id: 2,
  //   title: "HVAC Works",
  //   description: "",
  //   plannedDate: "23 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "HW",
  //   bgcolor: "#F7C7C3",
  //   color: "#F15744",
  // },
  // {
  //   id: 3,
  //   title: "Fire fighting works",
  //   description: "",
  //   plannedDate: "17 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "FF",
  //   bgcolor: "#F7C7C3",
  //   color: "#F15744",
  // },
  // {
  //   id: 4,
  //   title: "Plumbing works",
  //   description: "",
  //   plannedDate: "26 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "PW",
  //   bgcolor: "#DCFCE7",
  //   color: "#3CD856",
  // },
  // {
  //   id: 5,
  //   title: "ELV/FA-PA works",
  //   description: "",
  //   plannedDate: "10 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "EL",
  //   bgcolor: "#DCFCE7",
  //   color: "#3CD856",
  // },
  // {
  //   id: 6,
  //   title: "STP",
  //   description: "",
  //   plannedDate: "07 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "ST",
  //   bgcolor: "#DCFCE7",
  //   color: "#3CD856",
  // },
  // {
  //   id: 7,
  //   title: "AV-IT Works",
  //   description: "",
  //   plannedDate: "22 FEB, 2026",
  //   actualDate: "NA",
  //   avatar: "AV",
  //   bgcolor: "#DCFCE7",
  //   color: "#3CD856",
  // },
  // {
  //   id: 3,
  //   title:
  //     "Internal electrical system;Building earthing system;Toilets Internal electrical including exhaust system;FA & Detection system.",
  //   //poDate: "N.A",
  //   plannedDate: "30 DEC, 2025",
  //   actualDate: "N.A",
  //   avatar: "MD",
  // },
];
const getDelayAvatar = (data) => {

  const dueDate = data.plannedDate ? new Date(data.plannedDate) : null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (dueDate) dueDate.setHours(0, 0, 0, 0);
  if (dueDate && dueDate < today) {
    const diffMs = today - dueDate; // difference in milliseconds
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return diffDays;
  } else {
    return 0;
  }
}

const Dues = ({data, isLoading, isError}) => {
  const dispatch = useDispatch();
   const tableData = data?.items || [];

  const columns = [
    {
      name: "Items",
      field: "item",
      sticky: true,
      width: "30%",
      renderer: (row) => (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#F7C7C3",
              color: "#F15744",
              fontWeight: 500,
              fontSize: 18,
            }}
          >
            {getDelayAvatar(row)}
          </Avatar>

          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                fontFamily: "Outfit",
                color: "#101828",
                mb: 0.5,
                maxWidth: 240,
              }}
            >
              {row.itemName}
            </Typography>

            {row.description && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: 14,
                    fontFamily: "Outfit",
                    color: "#475467",

                  }}
                >
                  {row.description}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ),
    },

    {
      name: "Planned Date",
      field: "plannedDate",
      width: "30%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.plannedDate ? moment(row.plannedDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },

    {
      name: "Actual Date",
      field: "actualDate",
      width: "30%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.actualDate ? moment(row.actualDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },
  ];

  const handleExportExcel = () => {

    const formattedData = tableData.map((row, index) => ({
      "S.No": index + 1,
      "Title": row.title || "-",
      "Description": row.description || "-",
      "Planned Date": row.plannedDate && moment(row.plannedDate).isValid()
        ? moment(row.plannedDate).format(DEFAULT_DATE_FORMAT)
        : '-',
      "Actual Date": row.actualDate && moment(row.actualDate).isValid()
        ? moment(row.actualDate).format(DEFAULT_DATE_FORMAT)
        : '-',
    }));

    exportToExcel(formattedData, "Procurement_Floating_RFQ_Due");
    setTimeout(() => {
      openNotification("Excel exported successfully", "success");
    }, 0);
  };

  const openNotification = (msg, type = "error", duration = 3000) => {
    dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: 'alert',
        alert: {
          color: type
        },
        close: false
      })
    );
    setTimeout(() => dispatch(closeSnackbar()), duration);
  };

  return (
    <Grid container>
      <Grid size={12}>
        <TitleBar title={"Floating of RFQ Due this Month"} description={"Floating RFQs scheduled for issuance this month."}
          onExport={handleExportExcel}
        />
        <Box>
          <TableComponent
            columns={columns}
            data={tableData}
            isLoading={isLoading}
            createSortHandler={() => { }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Dues;
